jQuery(document).ready(function ($) {
  // image alt
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\..+$/, '');
    if (img.parent('a').length !== 0) {
      console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // breadcrumbs
  $('ul.breadcrumb').prepend('<li><a href="/">Home</a></li>');

  //View More for Directory
  $('.bio-content-toggle').click(function () {
    var $bio = $(this).parent();
    var $toggletext = $(this).children('.text');
    var $toggleButton = $(this).children('.fa');

    if ($bio.hasClass('expanded')) {
      $bio.removeClass('expanded');
      $toggletext.text("View More");
      $toggleButton.toggleClass('fa-caret-up');
    } else {
      $bio.addClass('expanded');
      $toggletext.text("View Less");
      $toggleButton.toggleClass('fa-caret-up');
    }
  });

  $('.bio-content-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      var $bio = $(this).parent();
      var $toggletext = $(this).children('.text');
      var $toggleButton = $(this).children('.fa');

      if ($bio.hasClass('expanded')) {
        $bio.removeClass('expanded');
        $toggletext.text("View More");
        $toggleButton.toggleClass('fa-caret-up');
      } else {
        $bio.addClass('expanded');
        $toggletext.text("View Less");
        $toggleButton.toggleClass('fa-caret-up');
      }
    }
  });

});

//Tables
$('#main').responsiveTables();